export default __webpack_public_path__ + "static/media/blockchain.921b90aa.png";